import { InvoiceSummaryBucketFilter } from '@finance-hub/domain/invoicing/blocs/types/unpaid-invoice-filters';

export const isInvoiceSummaryBucketFilterSelected = (
  filter: InvoiceSummaryBucketFilter,
  selectedFilter: InvoiceSummaryBucketFilter,
): boolean => {
  if (filter.kind === 'agingBucket') {
    return (
      selectedFilter.kind === 'agingBucket' &&
      selectedFilter.overdueBucket === filter.overdueBucket
    );
  }

  return selectedFilter.kind === filter.kind;
};
